var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.size > 0)?[_c('div',{staticClass:"file-type dark"},[_c('span',[_vm._v(_vm._s(_vm.format_size))])])]:_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321d230a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HkepDisplaySize.vue
// module id = kOsn
// module chunks = 2 3 4 5 6